<app-base-sidebar [topBarTemplate]="topBar" [bottomBarTemplate]="bottomBar">
	<app-chat-turns
		[turns]="conversation().turns"
		[progressMessages]="progressMessages()"
		(feedback)="giveFeedback($event.index, $event.sentiment)"
		[inspect]="data.inspect ?? false"
		(goToDashboard)="goToDashboardClick($event)"
	/>
	<ng-template #topBar>
		<h3 class="label">Chat: {{ conversation().onderwerp || "CumLaude Assistent" }}</h3>
		<app-icon
			#historyButton
			name="chat-history"
			color="primary-1"
			hoverColor="primary-1"
			(click)="openHistory()"
			appTooltip="Eerdere chats"
		></app-icon>
		<app-icon
			name="sluiten"
			size="small"
			color="primary-1"
			hoverColor="secondary-1"
			class="close-button"
			(click)="sidebarRef.requestClose()"
			appTooltip="Sidebar sluiten"
		></app-icon>
	</ng-template>
	<ng-template #bottomBar>
		<div class="input-container">
			<div class="user-prompt">
				<div class="prompt-row">
					<textarea
						#chatTextarea
						[(ngModel)]="userPrompt"
						autofocus
						placeholder="Bericht..."
						[disabled]="data.inspect || isLoading()"
						(keydown)="keyDown($event)"
					></textarea>
					<button class="send-button" (click)="sendUserPrompt()" [disabled]="!userPrompt().trim() || isLoading() || data.inspect">
						@if (isLoading()) {
							<span>Versturen...</span>
						} @else {
							<span>Verstuur</span>
						}
					</button>
				</div>
				@if (!data.inspect) {
					<div class="suggestions">
						@for (suggestion of suggestions(); track suggestion) {
							<button class="suggestion" (click)="selectSuggestion(suggestion)" [appTooltip]="suggestion.prompt">
								{{ suggestion.label }}
							</button>
						}
					</div>
				}
			</div>
			@if (conversation().turns.length > 0 && !data.inspect) {
				<div class="clear-container">
					<button class="clear-button" (click)="clearConversation()">
						<app-icon name="delete" color="primary-1" hoverColor="secondary-1" size="small"></app-icon>
					</button>
				</div>
			}
		</div>
		<div class="disclaimer">AI kan fouten maken. Controleer belangrijke informatie. <a href="#">Lees hier meer</a>.</div>
	</ng-template>
</app-base-sidebar>

<ng-template #feedbackDialog>
	<app-chat-feedback />
</ng-template>

<ng-template #historyDialog>
	<app-chat-history-dialog (selectChat)="selectHistoryChat($event)" [inspect]="data.inspect ?? false" />
</ng-template>
